import { createContext, useContext, useState, useEffect, ReactNode } from "react";

type TransportMode = "kollektiv" | "ferge";

interface TransportModeContextType {
  mode: TransportMode;
  setMode: (mode: TransportMode) => void;
  isFerryMode: boolean;
}

const TransportModeContext = createContext<TransportModeContextType | undefined>(undefined);

export function TransportModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<TransportMode>(() => {
    // Ferry is the default mode; only switch to kollektiv on explicit kollektiv paths
    const path = window.location.pathname;
    if (path === "/" && !window.location.search.includes('mode=kollektiv')) {
      return "ferge";
    }
    if (path === "/ferge" || path === "/ferger") {
      return "ferge";
    }
    return "kollektiv";
  });

  const isFerryMode = mode === "ferge";

  return (
    <TransportModeContext.Provider value={{ mode, setMode, isFerryMode }}>
      {children}
    </TransportModeContext.Provider>
  );
}

export function useTransportMode() {
  const context = useContext(TransportModeContext);
  if (context === undefined) {
    throw new Error("useTransportMode must be used within a TransportModeProvider");
  }
  return context;
}
